const wrapSVGContent = (viewBox, content) => `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${viewBox}">${content}</svg>`;
const systemIcons = {
  add: wrapSVGContent("0 0 24 24", '<path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2Z"/>'),
  "arrow-backwards": wrapSVGContent(
    "0 0 24 24",
    '<path d="m12 20 1.41-1.41L7.83 13H20v-2H7.83l5.58-5.59L12 4l-8 8 8 8Z"/>'
  ),
  "arrow-forward": wrapSVGContent(
    "0 0 24 24",
    '<path d="m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8Z"/>'
  ),
  "arrow-upward": wrapSVGContent(
    "0 0 24 24",
    '<path d="M4 12L5.41 13.41L11 7.83V20H13V7.83L18.58 13.42L20 12L12 4L4 12Z"/>'
  ),
  "back-arrow": wrapSVGContent(
    "0 0 24 24",
    '<path d="M18.28 3.77 16.283 2 5 12l11.283 10 1.997-1.77L8.994 12l9.286-8.23Z"/>'
  ),
  "calendar-today": wrapSVGContent(
    "0 0 24 24",
    '<path d="M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2Zm0 18H4V10h16v11Zm0-13H4V5h16v3Z"/>'
  ),
  calendar: wrapSVGContent(
    "0 0 24 24",
    '<path d="M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2Zm0 18H4V8h16v13Z"/>'
  ),
  "check-circle": wrapSVGContent(
    "0 0 24 24",
    '<path fill-rule="evenodd" d="M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12Zm8 2.17 6.59-6.59L18 9l-8 8-4-4 1.41-1.41L10 14.17Z" clip-rule="evenodd"/>'
  ),
  check: wrapSVGContent("0 0 24 24", '<path d="m8.59 15.58-4.17-4.17L3 12.82l5.59 5.59 12-12L19.18 5 8.59 15.58Z"/>'),
  close: wrapSVGContent(
    "0 0 24 24",
    '<path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41Z"/>'
  ),
  error: wrapSVGContent(
    "0 0 24 24",
    '<path fill-rule="evenodd" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm-1 15v-2h2v2h-2Zm0-10v6h2V7h-2Z" clip-rule="evenodd"/>'
  ),
  "favorite-border": wrapSVGContent(
    "0 0 24 24",
    '<path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3Zm-4.4 15.55-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05Z"/>'
  ),
  favorite: wrapSVGContent(
    "0 0 24 24",
    '<path d="m12 21.35-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35Z"/>'
  ),
  "filter-alt": wrapSVGContent(
    "0 0 24 24",
    '<path d="M6.962 6h10l-5.01 6.3L6.962 6Zm-2.75-.39C6.232 8.2 9.962 13 9.962 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39a.998.998 0 0 0-.79-1.61H5.002c-.83 0-1.3.95-.79 1.61Z"/>'
  ),
  "first-page": wrapSVGContent(
    "0 0 24 24",
    '<path d="M18.41 16.59 13.82 12l4.59-4.59L17 6l-6 6 6 6 1.41-1.41ZM6 6h2v12H6V6Z"/>'
  ),
  help: wrapSVGContent(
    "0 0 24 24",
    '<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm1 17h-2v-2h2v2Zm2.07-7.75-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25Z"/>'
  ),
  info: wrapSVGContent(
    "0 0 24 24",
    '<path d="M11 7h2v2h-2V7Zm0 4h2v6h-2v-6Zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Z"/>'
  ),
  "keyboard-arrow-left": wrapSVGContent(
    "0 0 24 24",
    '<path d="M15.41 16.59 10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41Z"/>'
  ),
  "keyboard-arrow-less": wrapSVGContent("0 0 24 24", '<path d="m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14l-6-6Z"/>'),
  "keyboard-arrow-more": wrapSVGContent("0 0 24 24", '<path d="M16.59 8 12 12.58 7.41 8 6 9.41l6 6 6-6L16.59 8Z"/>'),
  "keyboard-arrow-right": wrapSVGContent("0 0 24 24", '<path d="M8 16.59 12.58 12 8 7.41 9.41 6l6 6-6 6L8 16.59Z"/>'),
  "last-page": wrapSVGContent(
    "0 0 24 24",
    '<path d="M6 7.41 10.59 12 6 16.59 7.41 18l6-6-6-6L6 7.41ZM16.41 6h2v12h-2V6Z"/>'
  ),
  launch: wrapSVGContent(
    "0 0 24 24",
    '<path d="M16.667 16.667H7.333V7.333H12V6H7.333C6.593 6 6 6.6 6 7.333v9.334C6 17.4 6.593 18 7.333 18h9.334C17.4 18 18 17.4 18 16.667V12h-1.333v4.667ZM13.333 6v1.333h2.394l-6.554 6.554.94.94 6.554-6.554v2.394H18V6h-4.667Z"/>'
  ),
  lightbulb: wrapSVGContent(
    "0 0 24 24",
    '<path d="M9.429 21.15c0 .468.385.85.857.85h3.428a.856.856 0 0 0 .857-.85v-.85H9.43v.85ZM12 5c-3.309 0-6 2.669-6 5.95 0 2.023 1.02 3.8 2.571 4.879v1.921c0 .468.386.85.858.85h5.142a.856.856 0 0 0 .858-.85v-1.921C16.98 14.749 18 12.973 18 10.95 18 7.669 15.309 5 12 5Zm2.443 9.435-.729.51V16.9h-3.428v-1.955l-.729-.51a4.237 4.237 0 0 1-1.843-3.485c0-2.346 1.92-4.25 4.286-4.25 2.366 0 4.286 1.904 4.286 4.25a4.237 4.237 0 0 1-1.843 3.485ZM11 4h2V1h-2v3Zm8 8h3v-2h-3v2ZM2 12h3v-2H2v2Zm4.699-5.394 1.407-1.407-2.121-2.122-1.408 1.407L6.7 6.606Zm10.595.007 2.122-2.122-1.407-1.407-2.122 2.122 1.407 1.407Z"/>'
  ),
  "location-on": wrapSVGContent(
    "0 0 24 24",
    '<path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7ZM7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9Z"/><path d="M12 11.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"/>'
  ),
  lock: wrapSVGContent(
    "0 0 24 24",
    '<path d="M16.5 7.5h-.75V5.929C15.75 3.76 14.07 2 12 2 9.93 2 8.25 3.76 8.25 5.929V7.5H7.5c-.825 0-1.5.707-1.5 1.571v7.858c0 .864.675 1.571 1.5 1.571h9c.825 0 1.5-.707 1.5-1.571V9.07c0-.864-.675-1.571-1.5-1.571ZM9.75 5.929c0-1.305 1.005-2.358 2.25-2.358s2.25 1.053 2.25 2.358V7.5h-4.5V5.929Zm6.75 11h-9V9.07h9v7.858ZM12 14.57c.825 0 1.5-.707 1.5-1.571s-.675-1.571-1.5-1.571-1.5.707-1.5 1.571.675 1.571 1.5 1.571Z"/>'
  ),
  menu: wrapSVGContent("0 0 24 24", '<path d="M3 18h18v-2H3v2Zm0-5h18v-2H3v2Zm0-7v2h18V6H3Z"/>'),
  "play-arrow": wrapSVGContent("0 0 24 24", '<path d="M8 8.64 13.27 12 8 15.36V8.64ZM6 5v14l11-7L6 5Z"/>'),
  "play-circle-outline": wrapSVGContent(
    "0 0 24 24",
    '<path d="m10 16.5 6-4.5-6-4.5v9ZM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Z"/>'
  ),
  search: wrapSVGContent(
    "0 0 24 24",
    '<path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5Zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14Z"/>'
  ),
  sell: wrapSVGContent(
    "0 0 24 24",
    '<path d="m21.41 11.41-8.83-8.83c-.37-.37-.88-.58-1.41-.58H4c-1.1 0-2 .9-2 2v7.17c0 .53.21 1.04.59 1.41l8.83 8.83c.78.78 2.05.78 2.83 0l7.17-7.17c.78-.78.78-2.04-.01-2.83ZM12.83 20 4 11.17V4h7.17L20 12.83 12.83 20Z"/><path d="M6.5 8a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/>'
  ),
  spinner: wrapSVGContent(
    "0 0 32 32",
    '<path d="M16 32c-4.274 0-8.292-1.664-11.314-4.686s-4.686-7.040-4.686-11.314c0-3.026 0.849-5.973 2.456-8.522 1.563-2.478 3.771-4.48 6.386-5.791l1.344 2.682c-2.126 1.065-3.922 2.693-5.192 4.708-1.305 2.069-1.994 4.462-1.994 6.922 0 7.168 5.832 13 13 13s13-5.832 13-13c0-2.459-0.69-4.853-1.994-6.922-1.271-2.015-3.066-3.643-5.192-4.708l1.344-2.682c2.615 1.31 4.824 3.313 6.386 5.791 1.607 2.549 2.456 5.495 2.456 8.522 0 4.274-1.664 8.292-4.686 11.314s-7.040 4.686-11.314 4.686z"></path>'
  ),
  "table-sort": wrapSVGContent(
    "0 0 24 24",
    '<path d="M16.568 8.928H12.75v.018h-1.5v-.018H7.432L12 4.407l4.568 4.521Zm-9.136 6.144h9.136L12 19.593l-4.568-4.521Z"/>'
  ),
  "visibility-off": wrapSVGContent(
    "0 0 24 24",
    '<path d="M12 5.55a9.77 9.77 0 0 1 8.82 5.5 9.647 9.647 0 0 1-2.41 3.12l1.41 1.41c1.39-1.23 2.49-2.77 3.18-4.53-1.73-4.39-6-7.5-11-7.5-1.27 0-2.49.2-3.64.57l1.65 1.65c.65-.13 1.31-.22 1.99-.22Zm-1.07 1.14L13 8.76c.57.25 1.03.71 1.28 1.28l2.07 2.07c.08-.34.14-.7.14-1.07.01-2.48-2.01-4.49-4.49-4.49-.37 0-.72.05-1.07.14ZM2.01 3.42 4.69 6.1A11.738 11.738 0 0 0 1 11.05c1.73 4.39 6 7.5 11 7.5 1.52 0 2.98-.29 4.32-.82l3.42 3.42 1.41-1.41L3.42 2 2.01 3.42Zm7.5 7.5 2.61 2.61c-.04.01-.08.02-.12.02a2.5 2.5 0 0 1-2.5-2.5c0-.05.01-.08.01-.13Zm-3.4-3.4 1.75 1.75a4.6 4.6 0 0 0-.36 1.78 4.507 4.507 0 0 0 6.27 4.14l.98.98c-.88.24-1.8.38-2.75.38a9.77 9.77 0 0 1-8.82-5.5c.7-1.43 1.72-2.61 2.93-3.53Z"/>'
  ),
  visibility: wrapSVGContent(
    "0 0 24 24",
    '<path d="M12 6a9.77 9.77 0 0 1 8.82 5.5A9.77 9.77 0 0 1 12 17a9.77 9.77 0 0 1-8.82-5.5A9.77 9.77 0 0 1 12 6Zm0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4Zm0 5a2.5 2.5 0 0 1 0 5 2.5 2.5 0 0 1 0-5Zm0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7Z"/>'
  ),
  warning: wrapSVGContent(
    "0 0 24 24",
    '<path fill-rule="evenodd" d="M12 3 2 20h20L12 3Zm-1 15v-2h2v2h-2Zm0-10v6h2V8h-2Z" clip-rule="evenodd"/>'
  ),
  "quote-start": wrapSVGContent(
    "0 0 32 24",
    '<path d="M14.3827 0L9.53069 16.231L7.62455 8.95307C9.89651 8.95307 11.7256 9.58845 13.1119 10.8592C14.5367 12.13 15.2491 13.9013 15.2491 16.1733C15.2491 18.4067 14.5174 20.1974 13.0542 21.5451C11.6294 22.8929 9.81949 23.5668 7.62455 23.5668C5.4296 23.5668 3.60048 22.8929 2.13718 21.5451C0.712395 20.1974 0 18.4067 0 16.1733C0 15.5572 0.0385079 14.941 0.115524 14.3249C0.231047 13.7088 0.44284 12.9579 0.750902 12.0722C1.09747 11.1865 1.59807 10.0313 2.25271 8.6065L6.29603 0H14.3827ZM31.1336 0L26.2816 16.231L24.3755 8.95307C26.6474 8.95307 28.4765 9.58845 29.8628 10.8592C31.2876 12.13 32 13.9013 32 16.1733C32 18.4067 31.2684 20.1974 29.8051 21.5451C28.3803 22.8929 26.5704 23.5668 24.3755 23.5668C22.1805 23.5668 20.3514 22.8929 18.8881 21.5451C17.4633 20.1974 16.7509 18.4067 16.7509 16.1733C16.7509 15.5572 16.7894 14.941 16.8664 14.3249C16.982 13.7088 17.1937 12.9579 17.5018 12.0722C17.8484 11.1865 18.349 10.0313 19.0036 8.6065L23.0469 0H31.1336Z"/>'
  ),
  "quote-end": wrapSVGContent(
    "0 0 32 24",
    '<path d="M0.866426 23.5668L5.71841 7.33574L7.62455 14.6137C5.39109 14.6137 3.56197 13.9783 2.13718 12.7076C0.712395 11.3983 0 9.62696 0 7.3935C0 5.12154 0.712395 3.33093 2.13718 2.02166C3.60048 0.673888 5.4296 0 7.62455 0C9.81949 0 11.6294 0.673888 13.0542 2.02166C14.5174 3.33093 15.2491 5.12154 15.2491 7.3935C15.2491 8.00963 15.1913 8.62575 15.0758 9.24188C14.9988 9.858 14.8063 10.6089 14.4982 11.4946C14.1901 12.3418 13.6895 13.497 12.9964 14.9603L8.95307 23.5668H0.866426ZM17.6173 23.5668L22.4693 7.33574L24.3755 14.6137C22.142 14.6137 20.3129 13.9783 18.8881 12.7076C17.4633 11.3983 16.7509 9.62696 16.7509 7.3935C16.7509 5.12154 17.4633 3.33093 18.8881 2.02166C20.3514 0.673888 22.1805 0 24.3755 0C26.5704 0 28.3803 0.673888 29.8051 2.02166C31.2684 3.33093 32 5.12154 32 7.3935C32 8.00963 31.9422 8.62575 31.8267 9.24188C31.7497 9.858 31.5572 10.6089 31.2491 11.4946C30.941 12.3418 30.4404 13.497 29.7473 14.9603L25.704 23.5668H17.6173Z"/>'
  )
};
export {
  systemIcons
};
//# sourceMappingURL=iconset.system.js.map
